module.exports = __webpack_public_path__ + "media/images/icon_tel01_18-16-435a0da9bdcabe367ee549aae657edfb.png";